module.exports = __webpack_public_path__ + "img/DE01709.c1b25f4e.png";